<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 사업장 세부 정보 -->
    <field-info title="사업장 세부 정보" :fieldId="form.stdInfo.field_id" />

    <!-- 설계변경 -->
    <div class="print-container mt-5">
      <vs-row class="flex justify-between items-center my-4">
        <h5><i class="dot"></i> 설계변경</h5>
        <div v-if="!isPrint">
          <vs-button class="ml-4" color="secondary" @click="addTableRow"> 항목추가 </vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="deleteSelectTable"> 선택삭제 </vs-button>
        </div>
      </vs-row>
      <vs-table :multiple="!isPrint" v-model="selected" :data="form.tableList" class="w-full table" noDataText="">
        <template slot="thead">
          <vs-th> <div class="w-full text-center">차수(회차)</div> </vs-th>
          <vs-th> <div class="w-full text-center">변경 전 사업금액</div></vs-th>
          <vs-th> <div class="w-full text-center">변경 후 사업금액</div></vs-th>
          <vs-th> <div class="w-full text-center">증·감(금액, 원)</div> </vs-th>
          <vs-th> <div class="w-full text-center">설계변경 내용</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" style="box-shadow: none !important; transform: translateY(0px)">
            <vs-td class="w-2/12 text-center align-top">
              <div v-if="isPrint">{{ tr.num }}</div>
              <vs-input v-else :readonly="board.readonly" v-model="tr.num" class="w-full flex-1" @click.stop />
            </vs-td>
            <vs-td class="text-center align-top">
              <div v-if="isPrint">{{ comma(tr.prevAmount) }}</div>
              <vs-input
                v-else
                :readonly="board.readonly"
                :value="comma(tr.prevAmount)"
                @input="
                  (data) => {
                    tr.prevAmount = removeComma(data);
                  }
                "
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="text-center align-top">
              <div v-if="isPrint">{{ comma(tr.nextAmount) }}</div>
              <vs-input
                v-else
                :readonly="board.readonly"
                :value="comma(tr.nextAmount)"
                @input="
                  (data) => {
                    tr.nextAmount = removeComma(data);
                  }
                "
                class="w-full flex-1"
                @click.stop
              />
            </vs-td>
            <vs-td class="text-center align-top">
              <div v-if="isPrint">{{ diffAmount(tr.prevAmount, tr.nextAmount) }}</div>
              <vs-input v-else :readonly="true" :value="diffAmount(tr.prevAmount, tr.nextAmount)" class="w-full flex-1" @click.stop />
            </vs-td>
            <vs-td class="text-center align-top">
              <div v-if="isPrint">{{ tr.content }}</div>
              <vs-textarea v-else class="flex-1 w-full mb-0" rows="5" v-model="tr.content" :readonly="board.readonly" @click.stop />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- 발주자 정보 -->
    <div class="print-container mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 발주자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputC_1" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputC_2" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputC_3" class="w-full flex-1"></vs-input>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputC_4" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">지정된 담당자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputC_5" class="w-full flex-1"></vs-input>
        </div>
      </div>
    </div>

    <!-- 설계자 정보 -->
    <div class="print-container mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 설계자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_1 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputD_1" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_2 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputD_2" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_3 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputD_3" class="w-full flex-1"></vs-input>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_4 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputD_4" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">설계안전보건대장 담당자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_5 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputD_5" class="w-full flex-1"></vs-input>
        </div>
      </div>
    </div>

    <!-- 시공자 정보 -->
    <div class="print-container mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 시공자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_1 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_1" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_2 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_2" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장소장</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_3 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_3" class="w-full flex-1"></vs-input>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_4 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_4" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_5 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_5" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공사안전보건대장 작성 담당자(연락처)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputE_6 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputE_6" class="w-full flex-1"></vs-input>
        </div>
      </div>
    </div>

    <!-- 건설사업관리기술(감리) 정보 -->
    <div class="print-container mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 건설사업관리기술(감리) 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">회사명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_1 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputF_1" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_2 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputF_2" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_3 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputF_4" class="w-full flex-1"></vs-input>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_5 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputF_5" class="w-full flex-1"></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">현장 담당자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_6 }}</p>
          <vs-input :readonly="board.readonly" v-else v-model="form.inputF_6" class="w-full flex-1"></vs-input>
        </div>
      </div>
    </div>

    <!-- 관련내용 -->
    <div class="print-container mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 관련내용</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">내용</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputG_1 }}</p>
          <vs-textarea
            v-else
            class="flex-1 w-full"
            rows="5"
            v-model="form.inputG_1"
            :readonly="board.readonly"
            placeholder="□ 공사개요
□ 특수 구조물 개요
□ 주요 공법
2. 설계안전보건대장의 안전·보건조치 이행계획
3. 유해·위험방지계획서 심사 및 확인결과에 대한 조치내용(해당 시 작성)
4. 산업안전보건관리비 변경내역
5. 건설공사 산업재해예방 지도 계약여부, 지도결과 및 조치내용(해당 시 작성)
6. 작성(변경) 일자
7. 작성 및 확인자 등은 관련서식 작성 후 아래와 같이 파일첨부"
          />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import BusinessInfo from "@/components/BusinessInfo.vue";
import FieldInfo from "@/components/FieldInfo.vue";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    BusinessInfo,
    FieldInfo,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }

          if (key === "tableList") {
            if (typeof value[key] === "undefined") {
              value[key] = [];
            }
            if (value[key].length > 0) {
              this.tempId = value[key][value[key].length - 1].id;
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",
        inputB_9: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",

        inputE_1: "",
        inputE_2: "",
        inputE_3: "",
        inputE_4: "",
        inputE_5: "",
        inputE_6: "",

        inputF_1: "",
        inputF_2: "",
        inputF_3: "",
        inputF_4: "",
        inputF_5: "",
        inputF_6: "",

        inputG_1: "",

        fileList: [],
        tableList: [],
        businessInfo: {},
      },
      selected: [],
      tempId: 0,
    };
  },
  methods: {
    addTableRow() {
      this.form.tableList.push({
        id: ++this.tempId,
        num: null,
        prevAmount: 0,
        nextAmount: 0,
        content: null,
      });
    },
    deleteSelectTable() {
      const seletedIds = this.selected.map((item) => item.id);
      this.form.tableList = this.form.tableList.filter((item) => !seletedIds.includes(item.id));
    },
    diffAmount(num1, num2) {
      const amount = num2 - num1;
      return 0 < amount ? `+${this.comma(amount)}` : this.comma(amount);
    },
    comma(num) {
      const str = `${Number(num)}`;
      if (str && str.length > 0) {
        return str.replace(/,/gi, "").replace(/\B(?=(\d{3})+(?!\d))/gi, ",");
      }
    },
    removeComma(str) {
      return str.replace(/,/g, "");
    },
    updateBusiness(value) {
      this.form.businessInfo = value;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 16px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}

.table ::v-deep {
  .vs-con-tbody {
    background: none !important;
    border: 0 !important;
  }
  thead tr {
    background: #f9f9f9 !important;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
  }
  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;
  }
}
</style>
